import React, { useEffect, useState } from "react";
import { Button, Typography } from "@bca/ui-library";
import TrashRegularSVG from "./TrashRegularSVG";
export interface ClearAllFiltersButtonProps {
  filtersCount: number;
  onClearAllFilters?: () => void;
  underline?: boolean;
}

const ClearAllFiltersButton: React.FunctionComponent<ClearAllFiltersButtonProps> =
  ({ filtersCount, onClearAllFilters, underline = true }) => {
    const [hasCount, setHasCount] = useState(Boolean(filtersCount));

    useEffect(() => {
      setHasCount(Boolean(filtersCount));
    }, [filtersCount]);

    return (
      <Button
        disabled={!hasCount}
        height="41px"
        variant="tertiary"
        onClick={onClearAllFilters}
        aria-label="clear-all-filters"
        mr={0}
        ml={4}
        p={0}
        data-en="click"
        data-ec="button"
        data-el="filter"
        data-ea="clear-all"
        data-es=""
        css={`
          margin-left: 3px;
        `}
      >
        <TrashRegularSVG width="15px" height="14px" mb={underline ? 0 : 1} />
        <Typography
          variant="body"
          color="primary-light-blue"
          ml={1}
          css={
            underline &&
            `
            text-decoration: underline;
          `
          }
        >
          Clear all
        </Typography>
        {hasCount && (
          <Typography variant="body" color="grey-blue" ml={1}>
            ({filtersCount})
          </Typography>
        )}
      </Button>
    );
  };

export default ClearAllFiltersButton;
